import * as React from 'react';
import { Header } from 'semantic-ui-react';

import Pendiente, {
    Datos as PendienteDatos,
    inicial as pendienteInicial,
} from '../../../componentes/Pendiente';

export interface Datos {
    pendiente: PendienteDatos;
}

export const inicial: Datos = {
    pendiente: { ...pendienteInicial },
};

interface Props {
    tarjeta: Datos;
    onChange(tarjeta: Datos): void;
}

class Tarjeta extends React.Component<Props> {
    public render() {
        const { tarjeta, onChange } = this.props;

        return (
            <div>
                <Header as='h3'>Tarjeta</Header>

                <Pendiente
                    ancho='4'
                    datos={tarjeta.pendiente}
                    onChange={pendiente => {
                        onChange({ ...tarjeta, pendiente });
                    }}
                />
            </div>
        );
    }
}

export default Tarjeta;



// WEBPACK FOOTER //
// ./src/modulos/Matriculas/IngresoNuevaMatricula/componentes/S4Financieros/componentes/FormasPago/componentes/Tarjeta.tsx